import { QueryClient } from "react-query";
import MyExpApi from "../../enum/MyExpApi";
import { ApiRegistrationParticipantProgramDetails } from "../../../../shared/types/ApiRegistrationParticipantProgramDetails";
import TicketStatus from "../../../../shared/enums/TicketStatus";
import { getApiQueryKey, useGetApiData } from "shared/datalayer";
import { ApiRegistrationParticipantProfilePicture } from "shared/types/ApiRegistrationParticipantProfilePicture";

export function getParticipantDetailQueryKey(registrationParticipantId?: string) {
  return getApiQueryKey(MyExpApi.PARTICIPANT_DETAILS, {
    pathParams: { registrationParticipantId }
  });
}

export function useGetParticipantDetails(registrationParticipantId?: string) {
  return useGetApiData<ApiRegistrationParticipantProgramDetails>(
    MyExpApi.PARTICIPANT_DETAILS,
    {
      pathParams: { registrationParticipantId }
    },
    { enabled: Boolean(registrationParticipantId), hideLoader: true }
  );
}

export function refreshParticipantDetails(queryClient: QueryClient, regParticipantId?: string) {
  queryClient.invalidateQueries(getParticipantDetailQueryKey(regParticipantId));
}

export function updateTicketStatusInParticipantDetails(
  queryClient: QueryClient,
  regParticipantId?: string,
  ticketStatus?: TicketStatus
) {
  queryClient.setQueryData(
    getParticipantDetailQueryKey(regParticipantId),
    (data?: ApiRegistrationParticipantProgramDetails) => {
      return { ...data, ticketStatus: ticketStatus } as ApiRegistrationParticipantProgramDetails;
    }
  );
}

export function updateProfilePictureInParticipantDetails(
  queryClient: QueryClient,
  uploadResponse: ApiRegistrationParticipantProfilePicture
) {
  queryClient.setQueryData(
    getParticipantDetailQueryKey(uploadResponse.id),
    (data?: ApiRegistrationParticipantProgramDetails) => {
      return {
        ...data,
        profilePictureLocation: uploadResponse.profilePictureLocation,
        uiVersion: uploadResponse.uiVersion
      } as ApiRegistrationParticipantProgramDetails;
    }
  );
}
